module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [(_vm.showMain == true) ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v("d\n          "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Agent & CoLoader")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent / CoLoader")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "placeholder": "Select Type",
      "isDisabled": _vm.agentColaderModel.agntColoaderId != '' ? true : false
    },
    model: {
      value: (_vm.agentColaderModel.categoryType),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "categoryType", $$v)
      },
      expression: "agentColaderModel.categoryType"
    }
  }), _vm._v(" "), (!_vm.agentColaderModel.categoryType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.categoryTypeError))]) : _vm._e()], 1), _vm._v(" "), (_vm.agentColaderModel.categoryType == 'Agent') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Agent Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "agentName",
      "name": "agentName"
    },
    model: {
      value: (_vm.agentColaderModel.agentName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "agentName", $$v)
      },
      expression: "agentColaderModel.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.agentColaderModel.categoryType == 'CoLoader') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("CoLoader Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "coLoaderName",
      "name": "coLoaderName"
    },
    model: {
      value: (_vm.agentColaderModel.coLoaderName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "coLoaderName", $$v)
      },
      expression: "agentColaderModel.coLoaderName"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Contact No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contactNumber",
      "name": "contactNumber"
    },
    model: {
      value: (_vm.agentColaderModel.contactNumber),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "contactNumber", $$v)
      },
      expression: "agentColaderModel.contactNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Email-Id")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId"
    },
    model: {
      value: (_vm.agentColaderModel.emailId),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "emailId", $$v)
      },
      expression: "agentColaderModel.emailId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Company Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "companyName",
      "name": "companyName"
    },
    model: {
      value: (_vm.agentColaderModel.companyName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "companyName", $$v)
      },
      expression: "agentColaderModel.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address"
    },
    model: {
      value: (_vm.agentColaderModel.address),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "address", $$v)
      },
      expression: "agentColaderModel.address"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addAgentColoader
    }
  }, [_vm._v(_vm._s(_vm.agentColaderModel.agntColoaderId != '' ? 'Edit' : 'Add'))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Agent & CoLoader Details")]), _vm._v(" "), (_vm.showMain == false) ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px pull-right",
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("Add New")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2 pull-right back heght-20px",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getData('Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "agentCo12"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Category Type")]), _vm._v(" "), _c('th', [_vm._v("Agent Name")]), _vm._v(" "), _c('th', [_vm._v("CoLoader Name")]), _vm._v(" "), _c('th', [_vm._v("Contact Number")]), _vm._v(" "), _c('th', [_vm._v("Email Address")]), _vm._v(" "), _c('th', [_vm._v("Company Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allAgentColoaderData), function(item1, index) {
    return _c('tr', {
      key: index,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.viewEdit(item1)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.categoryType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item1.agentName != '') ? item1.agentName : '--'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item1.coLoaderName != '') ? item1.coLoaderName : '--'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.contactNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.emailId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.companyName))])])
  }))])])])])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dba7edf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/LEDGERMASTER/ledgerMaster.vue
// module id = 2730
// module chunks = 0